import { Spinner } from '../../../components/Common-components/spinner'
import { useUserReport } from '../hook/useUserReport'
import { PieChart, Pie } from 'recharts'
import { useCallback, useState } from 'react'
import { GoDotFill } from 'react-icons/go'
import { UserReportFilters } from '../component/userReportFilters'

export const DemographicsUsers = () => {
    const { data, methods } = useUserReport()
    const { loader, processedData } = data
    const { renderActiveShape, getTotalUsers } = methods
    const [activeIndex, setActiveIndex] = useState(0)
    const onPieEnter = useCallback(
        (_, index) => {
            setActiveIndex(index)
        },
        [setActiveIndex]
    )
    return (
        <>
            {loader && <Spinner />}
            <section className="filter">
                <UserReportFilters data={data} methods={methods} />
            </section>
            <section>
                <div className="d-flex flex-column p-2 align-items-end">
                    <div className="d-flex flex-column">
                        <span className="android fw-4 font-13 d-flex align-items-center">
                            <GoDotFill className="me-2" />
                            ANDROID
                        </span>
                        <span className="ios fw-4 font-13 d-flex align-items-center">
                            <GoDotFill className="me-2" />
                            IOS
                        </span>
                        <span className="web fw-4 font-13 d-flex align-items-center">
                            <GoDotFill className="me-2" />
                            WEB
                        </span>
                    </div>
                </div>
            </section>
            <section className="mt-3 d-flex justify-content-center h-100 align-items-center">
                <PieChart width={800} height={500} margin={{ left: 60 }}>
                    <Pie
                        activeIndex={activeIndex || 2}
                        activeShape={renderActiveShape}
                        data={processedData}
                        cx={'50%'}
                        cy={'50%'}
                        innerRadius={70}
                        outerRadius={90}
                        dataKey="value"
                        onMouseEnter={onPieEnter}
                    />
                    <text x="52%" y="50%" fontSize={20} fill="#333">
                        {getTotalUsers() || 0}
                    </text>
                    <text x="50%" y="55%" fontSize={12} fill="#999">
                        {'Total Users'}
                    </text>
                </PieChart>
            </section>
        </>
    )
}
